import { Component, OnInit } from '@angular/core';
import { FormService } from '../services/form.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ResultService } from '../services/result.service';
import { PagosData } from '../shared/models/pagosData';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {
  private inhabilitarCS = true;
  public decidir: any;
  public decidirInstance = null;
  public formSubmitted = false;
  public formPromise: Observable<any>;
  private routeParams: any = null;

  year = new Date().getFullYear().toString();
  yearNext = (new Date().getFullYear() + 1).toString();
  // DOM Elements
  public image: String;
  registerForm: FormGroup;
  submitted = false;
  subscription: Subscription
  medioPago = 0;
  bines = [];
  creditCardValid = true;
  private pagosData: PagosData;

  constructor(
    private formService: FormService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private router: Router,
    private resultService: ResultService,

  ) {
    this.route.params.subscribe(params => {
      this.routeParams = params;
    });
    this.image = this.routeParams.type;
  }

  ngOnInit() {
    // this.setSessionStorage(); // TEST
    this.checkSessionStorage();
    this.initDecidir();
    this.getBines();
    this.createForm();
  }

  get f() {
    return this.registerForm.controls;
  }

  private createForm() {
    this.registerForm = this.formBuilder.group({
      card: [
        '',
        [
          Validators.required,
          Validators.minLength(15),
          Validators.maxLength(19),
          Validators.pattern('[0-9]+')
        ]
      ],
      month: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.pattern('0[1-9]|1[0-2]')
        ]
      ],
      year: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.pattern(this.year.substr(2, 1) + '9|[' + this.yearNext.substr(2, 1) + '-9][0-9]'
          )
        ]
      ],
      name: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^[\u00F1A-Za-z _]*[\u00F1A-Za-z][\u00F1A-Za-z _]*$'
          )
        ]
      ],
      cvv: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.pattern('[0-9]+')
        ]
      ],
      typeDoc: ['dni'],
      docNumber: [
        '',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(8),
          Validators.pattern('[0-9]+')
        ]
      ],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}'
          )
        ]
      ]
    });
  }

  private initDecidir() {
    if (!!window['Decidir']) {
      this.decidir = window['Decidir'];
      this.decidirInstance = new this.decidir(
        environment.settings.UrlDecidir,
        this.inhabilitarCS
      );
      this.decidirInstance.setTimeout(5000);
      this.decidirInstance.setPublishableKey(
        environment.settings.DecidirPublicKey
      );

    }
  }

  public doPay(event: Event) {
    this.submitted = true;
    // stop here if form is invalid
    if (this.registerForm.invalid || !this.creditCardValid) {
      return false;
    }
    event.preventDefault();
    const data = {
      card_number: this.registerForm.controls.card.value,
      card_expiration_month: this.registerForm.controls.month.value,
      card_expiration_year: this.registerForm.controls.year.value,
      security_code: this.registerForm.controls.cvv.value,
      card_holder_name: this.registerForm.controls.name.value,
      card_holder_identification: {
        type: this.registerForm.controls.typeDoc.value,
        number: this.registerForm.controls.docNumber.value
      }
    }
    this.formService.paywayTokenize(data).subscribe((response: any) => {
      if (response && response.id) {
        this.sdkResponseHandler(response);
      } else {
        this.goToError();
      }
    }, () => { this.goToError() })
    return false;
  }

  public sdkResponseHandler(response) {
    let requestBody: any;
    requestBody = {
      id: response.id,
      email: this.registerForm.value.email,
      trx: this.routeParams.trx,
      cardHolderName: this.registerForm.value.name,
      cardHolderIdentificationNumber: this.registerForm.value.docNumber,
      cardHolderIdentificationType: this.registerForm.value.typeDoc,
    };

    if (this.image === 'masterDebito') {
      const bin = this.registerForm.value.card.substring(0, 9);
      requestBody.bin = bin;
    }
    this.formSubmitted = true;
    this.resultService.formRequest = requestBody;
    this.resultService.formPromise = this.formService.makePayment(requestBody);
  }

  private goToError() {
    this.formSubmitted = true;
    this.resultService.formPromise = this.formService.makePaymentErrr();
  }

  private checkSessionStorage() {
    this.pagosData = JSON.parse(sessionStorage.getItem('pagosData'));
    this.medioPago = this.pagosData && this.pagosData.idMedioPago ? this.pagosData.idMedioPago : JSON.parse(sessionStorage.getItem('medioPago'));
  }

  private setSessionStorage() {
    sessionStorage.setItem('medioPago', JSON.stringify(128));
  }

  private getBines() {
    const param = { dcuID: this.medioPago || 0 };
    this.formService.getBines(param).subscribe((result) => {
      if (result.data && result.data.length) {
        this.bines = result.data;
        const charLengthValidation = result.data[0].toString().length;
        this.creditCardValidation(charLengthValidation);
      }
    });
  }

  private creditCardValidation(charLengthValidation) {
    let valid = false;
    const regex = `^(${this.bines.join('|')})`;
    this.registerForm.controls.card.valueChanges.subscribe((value) => {
      if (value && value.length >= charLengthValidation && this.bines) {
        valid = value.match(regex);
        this.creditCardValid = valid !== null;
      } else {
        this.creditCardValid = true;
      }
    });
  }
}
